import React from 'react';
import _isNumber from 'lodash/isNumber';

import { UiKit } from 'components';

/**
 * @param {Object} props
 * @param {string} props.label
 * @param {"stack" | "inline"} props.variant
 * @param {string} props.tooltipText
 * @param {string} props.error
 * @param {boolean} props.disabled
 * @param {string} props.className
 * @param {import('utils/types').Space} props.gap
 * @param {React.ReactNode} props.children
 */
export default function Group({
  label = '',
  variant = 'stack',
  tooltipText = '',
  error = null,
  disabled = false,
  className = '',
  children = null,
  gap = undefined
}) {
  const isStacked = variant === 'stack';
  const defaultGap = isStacked ? 8 : 36;

  return (
    <UiKit.Flex direction="column" gap={4} className={className}>
      <UiKit.Title size="sm" tooltipText={tooltipText}>
        {label}
      </UiKit.Title>
      <UiKit.Flex
        direction={isStacked ? 'column' : 'row'}
        gap={_isNumber(gap) ? gap : defaultGap}
      >
        {children}
      </UiKit.Flex>
      <UiKit.Error msg={error} hide={disabled} />
    </UiKit.Flex>
  );
}
